<div class="container-fluid">
    <div class="row manageaccount mt-3">
        <div class="col-md-12 my-auto ">
            <div class="d-flex align-items-baseline justify-content-between">
                <h1 class="fs-4 fw-bold mb-0">View Vehicle</h1>
                <button class="btn btn-dark btn-sm " matTooltip="Back" matTooltipPosition="left" mat-raised-button
                    (click)="backTo()"><i class="fa-solid fa-arrow-left"></i></button>
            </div>
            <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item" (click)="backTo()">Manage Vehicle </li>
                    <li class="breadcrumb-item active" aria-current="page">View Vehicle</li>
                </ol>
            </nav>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-xl-12">
            <div class="contentbox">
                <div class="row account">
                    <div class="col-xl-12">
                        <div class="detailsBox">
                            <div class="row">
                                <div class="col-xl-3 mb-3">
                                    <label for="">Vehicle Number</label>
                                    <h5>{{particlarVehicle?.vehicle_no ? particlarVehicle?.vehicle_no:'N/A'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Vehicle Type</label>
                                    <h5>{{particlarVehicle?.type ? particlarVehicle?.type:'N/A'}}</h5>
                                </div>
                                <!-- <div class="col-xl-3">
                                    <label for="">Owner Name</label>
                                    <h5>{{particlarVehicle?.ownerName ? particlarVehicle?.ownerName :'N/A'}}</h5>
                                </div> -->
                                <div class="col-xl-3">
                                    <label for="">Driver Name</label>
                                    <h5>{{particlarVehicle?.driverName ? particlarVehicle?.driverName :'N/A'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Maker Name</label>
                                    <h5>{{particlarVehicle?.makerName ? particlarVehicle?.makerName :'N/A'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Chassis Number</label>
                                    <h5>{{particlarVehicle?.chassisNumber ? particlarVehicle?.chassisNumber :'N/A'}}
                                    </h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Engine Number</label>
                                    <h5>{{particlarVehicle?.engineNumber ? particlarVehicle?.engineNumber:'N/A'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Permit Number</label>
                                    <h5>{{particlarVehicle?.permitNumber ? particlarVehicle?.permitNumber:'N/A'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Policy Number</label>
                                    <h5>{{particlarVehicle?.policyNumber ? particlarVehicle?.policyNumber:'N/A'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">City</label>
                                    <h5>{{particlarVehicle?.city ? particlarVehicle?.city :'N/A'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Permit Due Date</label>
                                    <h5>{{(particlarVehicle?.permitDueDate ? particlarVehicle?.permitDueDate:'N/A') |
                                        date:'yyyy-MM-dd'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Permit 5 Years Due Date</label>
                                    <h5>{{(particlarVehicle?.permitYearsDueDate ? particlarVehicle?.permitYearsDueDate
                                        :'N/A') | date:'yyyy-MM-dd'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Purchase Date</label>
                                    <h5>{{(particlarVehicle?.purchaseDate ? particlarVehicle?.purchaseDate :'N/A') |
                                        date:'yyyy-MM-dd'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Road Tax Date</label>
                                    <h5>{{(particlarVehicle?.roadTaxDate ? particlarVehicle?.roadTaxDate :'N/A' )|
                                        date:'yyyy-MM-dd' }}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Insurance Due Date</label>
                                    <h5>{{(particlarVehicle?.insuranceDueDate ?
                                        particlarVehicle?.insuranceDueDate:'N/A') | date:'yyyy-MM-dd'}}</h5>
                                </div>
                                <div class="col-xl-3">
                                    <label for="">Fitness Due Date</label>
                                    <h5>{{(particlarVehicle?.fitnessDueDate ? particlarVehicle?.fitnessDueDate:'N/A') |
                                        date:'yyyy-MM-dd'}}</h5>
                                </div>
                                <div class="col-xl-3 mb-3">
                                    <label for="">Pollution Expiry Date</label>
                                    <h5>{{(particlarVehicle?.pollutionExpiryDate ?
                                        particlarVehicle?.pollutionExpiryDate:'N/A')| date:'yyyy-MM-dd'}}</h5>
                                </div>
                                <div class="col-xl-3 mb-3">
                                    <label for="">Permit</label>
                                    <div class="viewFile">
                                        <!-- If it's an image -->
                                        <div class="viewImage">
                                            <img [id]="apiUrl+'/uploads/'+particlarVehicle.permit"
                                                *ngIf="particlarVehicle.permit && !isPdf(particlarVehicle.permit)"
                                                [src]="apiUrl + '/uploads/' + particlarVehicle.permit" alt="Permit"
                                                onClick="viewImages(this, 'Permit')" />
                                        </div>
                                        <!-- If it's a PDF -->
                                        <div *ngIf="particlarVehicle.permit && isPdf(particlarVehicle.permit)"
                                            class="pdf-preview">
                                            <a [href]="apiUrl + '/uploads/' + particlarVehicle.permit" target="_blank">
                                                <i class="fa-regular fa-file-pdf text-danger me-1"></i>
                                                View Permit
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 mb-3">
                                    <label for="">RC Copy</label>
                                    <div class="viewFile">
                                        <!-- If it's an image -->
                                        <div class="viewImage">
                                            <img [id]="apiUrl+'/uploads/'+particlarVehicle.RCCopy"
                                                *ngIf="particlarVehicle.RCCopy && !isPdf(particlarVehicle.RCCopy)"
                                                [src]="apiUrl + '/uploads/' + particlarVehicle.RCCopy" alt="RC Copy"
                                                onClick="viewImages(this, 'RC Copy')" />
                                        </div>
                                        <!-- If it's a PDF -->
                                        <div *ngIf="particlarVehicle.RCCopy && isPdf(particlarVehicle.RCCopy)"
                                            class="pdf-preview">
                                            <a [href]="apiUrl + '/uploads/' + particlarVehicle.RCCopy" target="_blank">
                                                <i class="fa-regular fa-file-pdf text-danger me-1"></i>
                                                View RC Copy
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 mb-3">
                                    <label for="">Insurance</label>
                                    <div class="viewFile">
                                        <!-- If it's an image -->
                                        <div class="viewImage">
                                            <img [id]="apiUrl+'/uploads/'+particlarVehicle.insurance"
                                                *ngIf="particlarVehicle.insurance && !isPdf(particlarVehicle.insurance)"
                                                [src]="apiUrl + '/uploads/' + particlarVehicle.insurance"
                                                alt="Insurance" onClick="viewImages(this, 'Insurance')" />
                                        </div>
                                        <!-- If it's a PDF -->
                                        <div *ngIf="particlarVehicle.insurance && isPdf(particlarVehicle.insurance)"
                                            class="pdf-preview">
                                            <a [href]="apiUrl + '/uploads/' + particlarVehicle.insurance"
                                                target="_blank">
                                                <i class="fa-regular fa-file-pdf text-danger me-1"></i>
                                                View Insurance
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 mb-3">
                                    <label for="">Permit 5 Years</label>
                                    <div class="viewFile">
                                        <!-- If it's an image -->
                                        <div class="viewImage">
                                            <img [id]="apiUrl+'/uploads/'+particlarVehicle.permitYears"
                                                *ngIf="particlarVehicle.permitYears && !isPdf(particlarVehicle.permitYears)"
                                                [src]="apiUrl + '/uploads/' + particlarVehicle.permitYears"
                                                alt="Permit 5 Years" onClick="viewImages(this, 'Permit 5 Years')" />
                                        </div>
                                        <!-- If it's a PDF -->
                                        <div *ngIf="particlarVehicle.permitYears && isPdf(particlarVehicle.permitYears)"
                                            class="pdf-preview">
                                            <a [href]="apiUrl + '/uploads/' + particlarVehicle.permitYears"
                                                target="_blank">
                                                <i class="fa-regular fa-file-pdf text-danger me-1"></i>
                                                View Permit 5 Years
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 mb-3">
                                    <label for="">Road Tax</label>
                                    <div class="viewFile">
                                        <!-- If it's an image -->
                                        <div class="viewImage">
                                            <img [id]="apiUrl+'/uploads/'+particlarVehicle.roadTax"
                                                *ngIf="particlarVehicle.roadTax && !isPdf(particlarVehicle.roadTax)"
                                                [src]="apiUrl + '/uploads/' + particlarVehicle.roadTax" alt="Road Tax"
                                                onClick="viewImages(this, 'Road Tax')" />
                                        </div>
                                        <!-- If it's a PDF -->
                                        <div *ngIf="particlarVehicle.roadTax && isPdf(particlarVehicle.roadTax)"
                                            class="pdf-preview">
                                            <a [href]="apiUrl + '/uploads/' + particlarVehicle.roadTax" target="_blank">
                                                <i class="fa-regular fa-file-pdf text-danger me-1"></i>
                                                View Road Tax
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 mb-3">
                                    <label for="">Fitness</label>
                                    <div class="viewFile">
                                        <!-- If it's an image -->
                                        <div class="viewImage">
                                            <img [id]="apiUrl+'/uploads/'+particlarVehicle.fitness"
                                                *ngIf="particlarVehicle.fitness && !isPdf(particlarVehicle.fitness)"
                                                [src]="apiUrl + '/uploads/' + particlarVehicle.fitness" alt="Fitness"
                                                onClick="viewImages(this, 'Fitness')" />
                                        </div>
                                        <!-- If it's a PDF -->
                                        <div *ngIf="particlarVehicle.fitness && isPdf(particlarVehicle.fitness)"
                                            class="pdf-preview">
                                            <a [href]="apiUrl + '/uploads/' + particlarVehicle.fitness" target="_blank">
                                                <i class="fa-regular fa-file-pdf text-danger me-1"></i>
                                                View Fitness
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 mb-3">
                                    <label for="">Owner Pancard</label>
                                    <div class="viewFile">
                                        <!-- If it's an image -->
                                        <div class="viewImage">
                                            <img [id]="apiUrl+'/uploads/'+particlarVehicle.ownerPancard"
                                                *ngIf="particlarVehicle.ownerPancard && !isPdf(particlarVehicle.ownerPancard)"
                                                [src]="apiUrl + '/uploads/' + particlarVehicle.ownerPancard"
                                                alt="Owner Pancard" onClick="viewImages(this, 'Owner Pancard')" />
                                        </div>
                                        <!-- If it's a PDF -->
                                        <div *ngIf="particlarVehicle.ownerPancard && isPdf(particlarVehicle.ownerPancard)"
                                            class="pdf-preview">
                                            <a [href]="apiUrl + '/uploads/' + particlarVehicle.ownerPancard"
                                                target="_blank">
                                                <i class="fa-regular fa-file-pdf text-danger me-1"></i>
                                                View Owner Pancard
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 mb-3">
                                    <label for="">Owner Aadhar Card</label>
                                    <div class="viewFile">
                                        <!-- If it's an image -->
                                        <div class="viewImage">
                                            <img [id]="apiUrl+'/uploads/'+particlarVehicle.ownerAadharCard"
                                                *ngIf="particlarVehicle.ownerAadharCard && !isPdf(particlarVehicle.ownerAadharCard)"
                                                [src]="apiUrl + '/uploads/' + particlarVehicle.ownerAadharCard"
                                                alt="Owner Aadhar Card"
                                                onClick="viewImages(this, 'Owner Aadhar Card')" />
                                        </div>
                                        <!-- If it's a PDF -->
                                        <div *ngIf="particlarVehicle.ownerAadharCard && isPdf(particlarVehicle.ownerAadharCard)"
                                            class="pdf-preview">
                                            <a [href]="apiUrl + '/uploads/' + particlarVehicle.ownerAadharCard"
                                                target="_blank">
                                                <i class="fa-regular fa-file-pdf text-danger me-1"></i>
                                                View Owner Aadhar Card
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-3 mb-3">
                                    <label for="">Cancelled Cheque</label>
                                    <div class="viewFile">
                                        <!-- If it's an image -->
                                        <div class="viewImage">
                                            <img [id]="apiUrl+'/uploads/'+particlarVehicle.cancelledCheque"
                                                *ngIf="particlarVehicle.cancelledCheque && !isPdf(particlarVehicle.cancelledCheque)"
                                                [src]="apiUrl + '/uploads/' + particlarVehicle.cancelledCheque"
                                                alt="Cancelled Cheque" onClick="viewImages(this, 'Cancelled Cheque')" />
                                        </div>
                                        <!-- If it's a PDF -->
                                        <div *ngIf="particlarVehicle.cancelledCheque && isPdf(particlarVehicle.cancelledCheque)"
                                            class="pdf-preview">
                                            <a [href]="apiUrl + '/uploads/' + particlarVehicle.cancelledCheque"
                                                target="_blank">
                                                <i class="fa-regular fa-file-pdf text-danger me-1"></i>
                                                View Cancelled Cheque
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>